export default {"src":"/_next/static/media/CollectionIconCategoryActive.a09276ee.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};